import { DatesAvailabilityType } from '../models/entities/calendar.model';

export const dealerCalendar: DatesAvailabilityType = {
  availableDates: [
    '2022-11-23',
    '2022-11-24',
    '2022-11-27',
    '2022-11-28',
    '2022-11-29',
    '2022-11-30',
    '2022-12-01',
    '2022-12-04',
    '2022-12-05',
    '2022-12-06',
    '2022-07-07',
    '2022-07-08',
    '2022-07-11',
    '2022-07-12',
    '2022-07-13',
    '2022-07-14',
    '2022-07-15',
    '2022-07-18',
    '2022-07-19',
    '2022-07-20',
    '2022-07-21',
    '2022-07-22',
    '2022-07-25',
    '2022-07-26',
    '2022-07-27',
    '2022-07-28',
    '2022-07-29',
    '2022-08-01',
    '2022-08-02',
    '2022-08-03',
    '2022-08-04',
    '2022-08-05',
    '2022-08-08',
    '2022-08-09',
    '2022-08-10',
    '2022-08-11',
    '2022-08-12',
    '2022-08-15',
    '2022-08-16',
    '2022-08-17',
    '2022-08-18',
    '2022-08-19',
    '2022-08-22',
    '2022-08-23',
    '2022-08-24',
    '2022-08-25',
    '2022-08-26',
    '2022-08-29',
    '2022-08-30',
    '2022-08-31',
    '2022-09-01',
    '2022-09-02',
    '2022-09-05',
    '2022-09-06',
    '2022-09-07',
    '2022-09-08',
    '2022-09-09',
  ],
  closedDates: [
    '2022-05-29',
    '2022-06-04',
    '2022-06-05',
    '2022-06-11',
    '2022-06-12',
    '2022-06-18',
    '2022-06-19',
    '2022-06-25',
    '2022-06-26',
    '2022-07-02',
    '2022-07-03',
    '2022-07-09',
    '2022-07-10',
    '2022-07-16',
    '2022-07-17',
    '2022-07-23',
    '2022-07-24',
    '2022-07-30',
    '2022-07-31',
    '2022-08-06',
    '2022-08-07',
    '2022-08-13',
    '2022-08-14',
    '2022-08-20',
    '2022-08-21',
    '2022-08-27',
    '2022-08-28',
    '2022-09-03',
    '2022-09-04',
  ],
};

export const selectedDate = {
  start: new Date(),
};
